import { Component, type ErrorInfo, type ReactNode } from "react";

// jmix-exit E3a.3: a React render-error boundary so an exception in one screen degrades to the shared
// error surface instead of a blank white page (part of the error/empty/loading conventions). Epic 3b
// / a later observability story can wire `componentDidCatch` to a backend problem sink; for now it
// logs to the console. Class component because React error boundaries have no hook equivalent.

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}
interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error("[platform-spa] render error", error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="fawkes-state" role="alert">
            <section className="fui-card">
              <div className="fawkes-state__body">
                <h2 className="fawkes-state__title">Er ging iets mis</h2>
                <p className="fawkes-state__text">
                  Het scherm kon niet worden geladen. Ververs de pagina om het opnieuw te proberen.
                </p>
              </div>
            </section>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
